import React from 'react';
import { useFormikContext } from 'formik';

import { NavigationGuard } from './NavigationGuard';

export default function EnhancedNavigationGuard(props) {
    const { dirty, status } = useFormikContext();
    const blocked = status !== 'success' && dirty;

    return <NavigationGuard blocked={blocked} {...props} />;
}
